import React from "react"
import { Badge } from "react-native-paper"
import { theme } from "../../theme/theme"

export function BadgeM({
    count,
    style,
    size = null,
    customContent = null,
    backgroundColor = theme.colors.white,
}) {
    if (size)
        return (
            <Badge
                style={{
                    backgroundColor,
                    color: theme.colors.link,
                    fontFamily: "Montserrat-Bold",
                    alignSelf: "center",
                    ...style,
                }}
                size={size}
            >
                {count ? count : customContent ? customContent : null}
            </Badge>
        )
    else
        return (
            <Badge
                style={{
                    backgroundColor,
                    color: theme.colors.link,
                    fontFamily: "Montserrat-Bold",
                    alignSelf: "center",
                    ...style,
                }}
            >
                {count ? count : customContent ? customContent : null}{" "}
            </Badge>
        )
}
